module.exports = {"id":"214384","name":"Felipe Aguilar","rating":"72","photo":"./data/images/photos/0/214384.png","club":{"name":"Atl. Nacional","logo":"./data/images/clubs/Atl.Nacional.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/FelipeAguilar0.json
// module id = 1397
// module chunks = 0